<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4 v-if="dataId==null">Ajouter Formation</h4>
        <h4 v-if="dataId!=null">Modifier Formation {{dataTitre}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
  
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <!-- Product Image -->
        <template v-if="dataAvatar">

          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center">
            <img :src="dataAvatar" alt="img" class="responsive">
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Mettre à jour Image</vs-button>
            <vs-button type="flat" color="#999" @click="dataAvatar = null">Supprimer Image</vs-button>
          </div>
        </template>

        <!-- titre -->
        <vs-input label="Titre" v-model="dataTitre" class="mt-5 w-full" titre="item-titre" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-titre')">{{ errors.first('item-titre') }}</span>
        <!-- prix -->
        <!-- <vs-input label="Prix" v-model="dataPrix" class="mt-5 w-full" name="item-prix" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-prix')">{{ errors.first('item-prix') }}</span> -->
        <!-- salaire -->
       
        <!-- description -->
        <vs-input label="Description" v-model="dataDescription" class="mt-5 w-full" name="item-description" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-description')">{{ errors.first('item-description') }}</span>
        
        <!-- domaine-->
        <vs-select v-model="dataDomaine" label="Domaine" class="mt-5 w-full" name="item-domaine" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in domaine_choices" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-domaine')">{{ errors.first('item-domaine') }}</span>
        
        <!-- ORDER STATUS 
        <vs-select v-model="dataOrder_status" label="Order Status" class="mt-5 w-full">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in order_status_choices" />
        </vs-select>
-->
        <!-- PRICE 
        <vs-input
          icon-pack="feather"
          icon="icon-dollar-sign"
          label="Price"
          v-model="dataPrice"
          class="mt-5 w-full"
          v-validate="{ required: true, regex: /\d+(\.\d+)?$/ }"
          name="item-price" />
        <span class="text-danger text-sm" v-show="errors.has('item-price')">{{ errors.first('item-price') }}</span>
-->
        <!-- Upload -->
        <!-- <vs-upload text="Upload Image" class="img-upload" ref="fileUpload" /> -->

        <div class="upload-img mt-5" v-if="!dataAvatar">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
          <vs-button @click="$refs.uploadImgInput.click()">Image de la formation</vs-button>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button v-if="dataId==null" class="mr-6" @click="submitData" :disabled="!isFormValid">Ajouter</vs-button>
      <vs-button v-if="dataId!=null" class="mr-6" @click="submitData" :disabled="!isFormValid">Modifier</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Annuler</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
//import axios from "../../../http/axios/index.js"
import moduledomaine from '@/store/domaine/moduledomaine.js'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
     
      if(!val) return
      if(Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      }else {
        let { salaire_formateur,domaine_id,description, id, image, titre, nom_domaine, prix } = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataDescription = description
        this.dataAvatar = image
        this.dataTitre = titre
        this.dataPrix = prix
        this.dataNom_domaine = nom_domaine
        this.dataDomaine = domaine_id
        this.initValues()
       
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {
      change_image: false,
      newformation: false,
      file: null, 
      dataTitre: null, 
      datadomaine: null,
      datadescription: null,
      dataprix: null,
      dataNom_domaine: null,
      dataId: null,
      dataAvatar: null,
      dataOrder_status: "pending",
      dataPrice: 0,

      category_choices: [],
      
      
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
    domaineData() {
      return this.$store.state.domaine.users
    },
    isSidebarActiveLocal: {
      get() {
        console.log(this.isSidebarActive)
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    domaine_choices() {
        let opts=[];
          for (var domaine of this.$store.state.domaine.users) {
              opts.push({text: domaine.nom_domaine, value: domaine.id});
              
            }
            
      return opts
    },
    domaine_local: {
      get() {
        console.log(this.dataNom_domaine)
        return { text: this.dataNom_domaine,  value: this.dataDomaine  }
      },
      set(obj) {
        this.dataNom_domaine = obj.label
        this.dataDomaine = obj.value
        console.log(this.dataNom_domaine)
      }
    },
    isFormValid() {
      return !this.errors.any() 
    }
  },
  methods: {
    initValues() {
      if(this.data.id) return
        this.dataId = null
        this.dataTitre = ""
        this.dataPrix = null
        this.dataAvatar = null
        this.dataDescription = null
        this.dataNom_domaine = null
        this.dataDomaine = null
    },
    submitData() {
      this.$validator.validateAll().then(result => {
          
          if (result) {
            this.newformation= true
            console.log('this.newformation',this.newformation)
            const obj = {
              id: this.dataId,
              titre: this.dataTitre,
              //image: this.dataavatar,
              prix: this.dataPrix,
              description: this.dataDescription,

              domaine_id: this.dataDomaine,
              avatar: this.dataAvatar
            }
                  
         console.log('obj1',obj)
            //this.$store.dispatch("formation/addItem", obj).catch(err => { console.error(err) });    
            //this.showMessage('success', 'Added', 'successfully added') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not Added', 'an error in add: '+ err) })
          
              //this.$store.dispatch("formation/addItem", obj).catch(err => { console.error(err) })
              if(!obj.id){
              this.$store.dispatch("formation/addItem", obj).then(()   => {  this.$store.dispatch("formation/fetchUsers").catch(err => { console.error(err) });  this.showMessage('success', 'ajouter', 'ajouté avec succès') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'pas ajouté', 'une erreur: '+ err) })
              console.log('newformation')
              }else{
                console.log('updateformation')
                console.log('obj2',obj)
                console.log('obj.avatar',obj.avatar)
               this.$store.dispatch("formation/updateRecord", obj).then(()   => {  this.$store.dispatch("formation/fetchUsers").catch(err => { console.error(err) });  this.showMessage('success', 'mise à jour', 'mise à jour avec succès') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'pas de mise à jour', 'une erreur: '+ err) })
               if(this.change_image){
                this.$store.dispatch("formation/updateavatarRecord", obj).then(()   => { this.$store.dispatch("formation/fetchUsers").catch(err => { console.error(err) });  /*this.showMessage('success', 'mise à jour', 'mise à jour image avec succès')*/ }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); /*this.showMessage('danger', 'pas de mise à jour', 'une erreur: '+ err)*/ })
                console.log('updateformation image ')
                }
              }

            this.$emit('closeSidebar')
            this.initValues()
            console.log(this.data)
            //const image = this.file
            //axios.post('http://127.0.0.1:8000/api/addformation',obj,image)
          }
      })
    
    },
    showMessage(color, title, text) {
              this.$vs.notify({
                color: color,
                title: 'Formation '+title,
                text: 'La nouveau domaine '+text
              })
            },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.dataAvatar = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
         this.file = input.target.files[0]
       this.change_image = true
       console.log("this.change_image",this.change_image)
      }
    }
  },
  components: {
    VuePerfectScrollbar,
  },
  created() {
  if(!moduledomaine.isRegistered) {
      this.$store.registerModule('domaine', moduledomaine)
      moduledomaine.isRegistered = true
    }
   this.$store.dispatch("domaine/fetchUsers").catch(err => { console.error(err) })


  }

    
  
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
